export default __webpack_public_path__ + "static/media/pet_paw_icon.16c57541.svg";